import { createFileRoute } from '@tanstack/react-router';

import { EsgOnboardingHomePage } from '@/features/esg/components/EsgOnboardingHomePage';

export const Route = createFileRoute('/_authenticated/esg/onboarding/')({
  beforeLoad: () => ({
    getTitle: () => 'CSRD Onboarding',
  }),
  component: EsgOnboardingHomeRoute,
});

function EsgOnboardingHomeRoute() {
  return <EsgOnboardingHomePage />;
}
